import React from 'react';

const Vue_beforeCreate = () => {
  return (
    <div>
      <h1>Vue_beforeCreate Component</h1>
      <p>This is the Vue_beforeCreate tutorial page.</p>
    </div>
  );
}

export default Vue_beforeCreate;
